import { useState, type FormEvent } from "react";
import { IconArrow } from "../components/icons";

const EMAIL = "hello@agile-software.co.uk";

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  // No backend yet (Phase 1 is a static site): compose a pre-filled email in
  // the visitor's own mail client. A server-side form handler is a later phase.
  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    const subject = `Project enquiry — ${name || "website"}`;
    const body = `${message}\n\n— ${name}\n${email}`;
    window.location.href = `mailto:${EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  return (
    <>
      <section className="pagehead">
        <div className="container">
          <p className="eyebrow">Contact</p>
          <h1 className="display-lg">Tell us what you&rsquo;re trying to do.</h1>
          <p className="lead">
            A sentence or two is plenty to start. We&rsquo;ll reply with a few questions
            and, if it&rsquo;s a fit, book a short discovery call.
          </p>
        </div>
      </section>

      <section className="section" style={{ paddingTop: "clamp(16px, 3vw, 32px)" }}>
        <div className="container contact-grid">
          <div>
            <div className="contact-detail">
              <span className="k">Email</span>
              <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
            </div>
            <div className="contact-detail">
              <span className="k">Web</span>
              <a href="https://agile-software.co.uk">agile-software.co.uk</a>
            </div>
            <div className="contact-detail">
              <span className="k">Hours</span>
              <span>Mon&ndash;Fri, 9:00&ndash;17:30 (UK)</span>
            </div>
            <div className="contact-detail">
              <span className="k">Response time</span>
              <span>Usually within one working day</span>
            </div>
          </div>

          <form onSubmit={handleSubmit} noValidate>
            <div className="field">
              <label htmlFor="name">Your name</label>
              <input id="name" name="name" value={name} onChange={(e) => setName(e.target.value)} required autoComplete="name" />
            </div>
            <div className="field">
              <label htmlFor="email">Email</label>
              <input id="email" name="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
            </div>
            <div className="field">
              <label htmlFor="message">What do you need?</label>
              <textarea id="message" name="message" value={message} onChange={(e) => setMessage(e.target.value)} required placeholder="A sentence or two about the problem you're trying to solve." />
            </div>
            <button type="submit" className="btn">Send message <IconArrow /></button>
            <p style={{ fontSize: 13, color: "var(--slate)", marginTop: 14 }}>
              This opens a pre-filled email in your mail app. Prefer to write directly?
              Email <a href={`mailto:${EMAIL}`} style={{ color: "var(--teal-deep)", fontWeight: 600 }}>{EMAIL}</a>.
            </p>
          </form>
        </div>
      </section>
    </>
  );
}
